export const dynamicFields = [

  {
    label: "Nombre del cliente",
    value: "{{clientName}}",
  },

  {
    label: "Correo electrónico",
    value: "{{clientEmail}}",
  },

  {
    label: "Número de teléfono",
    value: "{{phone}}",
  },

  {
    label: "Número de reservación",
    value: "{{reservationNumber}}",
  },

  {
    label: "Fecha de reservación",
    value: "{{reservationDate}}",
  },

  {
    label: "Número de pasajeros",
    value: "{{passengers}}",
  },

  {
    label: "Lugar de recogida",
    value: "{{locationFromName}}",
  },

  {
    label: "Lugar de destino",
    value: "{{locationToName}}",
  },

  {
    label: "Duración",
    value: "{{durationLabel}}",
  },

  {
    label: "Tipo de servicio",
    value: "{{serviceTypeName}}",
  },

  {
    label: "Categoría del servicio",
    value: "{{serviceCategory}}",
  },

  {
    label: "Estado",
    value: "{{status}}",
  },

  {
    label: "Moneda",
    value: "{{currency}}",
  },

  {
    label: "Símbolo de moneda",
    value: "{{symbol}}",
  },

  {
    label: "Subtotal",
    value: "{{subtotal}}",
  },

  {
    label: "Impuestos",
    value: "{{taxAmount}}",
  },

  {
    label: "Total",
    value: "{{total}}",
  },

  {
    label: "Nombre del colaborador",
    value: "{{staffName}}",
  },

  {
    label: "Notas",
    value: "{{notes}}",
  },

  {
    label: "Título de la reserva",
    value: "{{title}}",
  },

  {
    label: "Nombre de empresa",
    value: "{{companyName}}",
  },

];